import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Category as SchemaCategory } from '../schemas/Category';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Categories
 */
export const GetCategoriesContentType = '' as const;
export type GetCategoriesRequest = void;
export type GetCategoriesResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaCategory[];
    };
};
export type GetCategoriesResponseSuccess = GetCategoriesResponses['200']['application/json'];
export type GetCategoriesSearchParams = undefined;
export type GetCategoriesPathParameters = undefined;
export const GetCategoriesUrl = '/categories' as const;
export const GetCategoriesMethod = 'GET' as const;
export const getGetCategoriesUrl = (_params?: GetCategoriesPathParameters) => GetCategoriesUrl;
